import { drawerAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  overlay: {
    bg: 'backgrounds.overlay',
  },
  dialog: {
    borderRadius: 'drawerRadius',
  },
  closeButton: {
    color: 'text.faded',
    fontSize: 'l',
    top: '5',
  },
  header: {
    borderBottom: 'section',
    backgroundColor: 'table.footer',
  },
  body: {
    borderRadius: 'dialogerBodyRadius',
    backgroundColor: 'table.footer',
  },
});

const variants = {
  top: {
    dialog: {
      borderRadius: 'dialogerRadiusTop',
    },
  },
  bottom: {
    dialog: {
      borderRadius: 'dialogerRadiusBottom',
    },
  },
  right: {
    dialog: {
      borderRadius: 'dialogerRadiusRight',
    },
  },
  left: {
    dialog: {
      borderRadius: 'dialogerRadiusLeft',
    },
  },
};

export const Drawer = defineMultiStyleConfig({
  baseStyle,
  variants,
});
